import { LexoRank } from '../sorting';
import { compareByString } from './compareByString';

export const compareByLexorank = (a: LexoRank, b: LexoRank): number => {
    return compareByString(a, b);
};
